// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"SideDrawe__SideDrawer__wnl5F","Open":"SideDrawe__Open__jZVOw","Close":"SideDrawe__Close__3G7NF","Logo":"SideDrawe__Logo__2inbo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SideDrawer/SideDrawe.css
// module id = 88
// module chunks = 3